// Path: ./src/app/components/SelectMui/styled.ts
import styled from "styled-components";

interface PropsWrapper {
  wrapperStyle?: string;
}
export const Wrapper = styled.div<PropsWrapper>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  ${(props) => {
    return props?.wrapperStyle ? props.wrapperStyle : "";
  }}
`;
export const Text = styled.div`
  margin-left: 8px;
`;
